import { render, staticRenderFns } from "./UpSellProductListing.vue?vue&type=template&id=30102506&scoped=true&"
import script from "./UpSellProductListing.vue?vue&type=script&lang=ts&"
export * from "./UpSellProductListing.vue?vue&type=script&lang=ts&"
import style0 from "./UpSellProductListing.vue?vue&type=style&index=0&id=30102506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30102506",
  null
  
)

export default component.exports